export const STORAGE_KEY = "digitalPortal_monitoramentoPreco_coletas";

/** Paleta alinhada às referências visuais do formulário (não usa tema do portal). */
export const MP = {
  primary: "#0056b3",
  primaryHover: "#004494",
  primarySoft: "#e8f2fc",
  text: "#1a1d21",
  textMuted: "#5c6570",
  border: "#dde1e6",
  cardBg: "#ffffff",
  pageBg: "#eef2f7",
  tableHead: "#f0f2f5",
  danger: "#c62828",
  radiusLg: 10,
  radiusMd: 8,
  shadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
  font: '"Inter", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
};
